export default "__VITE_ASSET__DVOBOykG__"